import React from 'react';
import Button from '../../../components/Button';
import MuiCheckIcon from '@material-ui/icons/CheckCircle';
import _Link from '../../../components/Link';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import { Container } from '../../../components/view/FormBuilderStatusesView';
import IntegrationsCardEngine from '../engine/IntegrationsCardEngine';
import Colors from '../../Colors';

const Link = styled(_Link)`
  font-weight: 500 !important;
`;

const CheckIcon = styled(MuiCheckIcon)`
  color: ${Colors.PRIMARY};
  height: 1.2rem !important;
  width: 1.2rem !important;
`;

const FormBuilderIntegrationsView = props => {
  const t = useTranslations();
  const docusignConnected =
    props.docusignData && props.docusignData.id !== 'new';
  const thirdfortConnected =
    props.thirdfortData && props.thirdfortData.id !== 'new';
  const worldcheckConnected =
    props.worldcheckData && props.worldcheckData.id !== 'new';
  const credasConnected = props.credasData && props.credasData.id !== 'new';
  if (!props.checkedAndNotConnecting) {
    return '';
  }
  return (
    <Container>
      <IntegrationsCardEngine
        iconUrl="icons/docusign.png"
        title={
          <>
            {t('form-builder.integrations.docusign.title')}
            &nbsp;{docusignConnected ? <CheckIcon /> : ''}
          </>
        }
        subTitle={
          <>
            {docusignConnected
              ? t('form-builder.integrations.docusign.tagline_connected')
              : t('form-builder.integrations.docusign.tagline')}
            <br />
            {props.anonymous ? (
              <>
                DocuSign integration cannot be used with an &nbsp;
                <Link
                  data-testid="docusign.anonymous_form"
                  onClick={props.clickedAnonymous}
                >
                  anonymous form
                </Link>
              </>
            ) : !props.licensed ? (
              <>
                To license this integration contact &nbsp;
                <Link
                  data-testid="docusign.email_link"
                  href="mailto:enquiries@vinciworks.com"
                >
                  enquiries@vinciworks.com
                </Link>
              </>
            ) : (
              ''
            )}
          </>
        }
        actions={
          <Button
            disabled={!props.licensed || props.anonymous}
            onClick={props.gotoDocusignPage}
          >
            {docusignConnected ? 'Edit account' : 'Connect account'}
          </Button>
        }
      />
      <IntegrationsCardEngine
        iconUrl="icons/thirdfort.png"
        title={
          <>
            {t('form-builder.integrations.thirdfort.title')}
            &nbsp;{thirdfortConnected ? <CheckIcon /> : ''}
          </>
        }
        subTitle={
          <>
            {thirdfortConnected
              ? t('form-builder.integrations.thirdfort.tagline_connected')
              : t('form-builder.integrations.thirdfort.tagline')}
            <br />
            {props.anonymous ? (
              <>
                Thirdfort integration cannot be used with an &nbsp;
                <Link
                  data-testid="thirdfort.anonymous_form"
                  onClick={props.clickedAnonymous}
                >
                  anonymous form
                </Link>
              </>
            ) : !props.thirdfortLicensed ? (
              <>
                To license this integration contact &nbsp;
                <Link
                  data-testid="docusign.email_link"
                  href="mailto:enquiries@vinciworks.com"
                >
                  enquiries@vinciworks.com
                </Link>
              </>
            ) : (
              ''
            )}
          </>
        }
        actions={
          <Button
            disabled={!props.thirdfortLicensed || props.anonymous}
            onClick={props.gotoThirdfortPage}
          >
            {thirdfortConnected ? 'Edit account' : 'Connect account'}
          </Button>
        }
      />
      <IntegrationsCardEngine
        iconUrl="icons/refinitiv.png"
        title={
          <>
            {t('form-builder.integrations.worldcheck.title')}
            &nbsp;{worldcheckConnected ? <CheckIcon /> : ''}
          </>
        }
        subTitle={
          <>
            {worldcheckConnected
              ? t('form-builder.integrations.worldcheck.tagline_connected')
              : t('form-builder.integrations.worldcheck.tagline')}
            <br />
            {props.anonymous ? (
              <>
                Refinitiv World-Check integration cannot be used with an &nbsp;
                <Link
                  data-testid="worldcheck.anonymous_form"
                  onClick={props.clickedAnonymous}
                >
                  anonymous form
                </Link>
              </>
            ) : !props.worldcheckLicensed ? (
              <>
                To license this integration contact &nbsp;
                <Link
                  data-testid="worldcheck.email_link"
                  href="mailto:enquiries@vinciworks.com"
                >
                  enquiries@vinciworks.com
                </Link>
              </>
            ) : (
              ''
            )}
          </>
        }
        actions={
          <Button
            disabled={!props.worldcheckLicensed || props.anonymous}
            onClick={props.gotoWorldcheckPage}
          >
            {worldcheckConnected ? 'Edit account' : 'Connect account'}
          </Button>
        }
      />
      <IntegrationsCardEngine
        iconUrl="icons/credas-logo.svg"
        title={
          <>
            {t('form-builder.integrations.credas.title')}
            &nbsp;{credasConnected ? <CheckIcon /> : ''}
          </>
        }
        subTitle={
          <>
            {credasConnected
              ? t('form-builder.integrations.credas.tagline_connected')
              : t('form-builder.integrations.credas.tagline')}
            <br />
            {props.anonymous ? (
              <>
                Credas integration cannot be used with an &nbsp;
                <Link
                  data-testid="credas.anonymous_form"
                  onClick={props.clickedAnonymous}
                >
                  anonymous form
                </Link>
              </>
            ) : !props.credasLicensed ? (
              <>
                To license this integration contact &nbsp;
                <Link
                  data-testid="credas.email_link"
                  href="mailto:enquiries@vinciworks.com"
                >
                  enquiries@vinciworks.com
                </Link>
              </>
            ) : (
              ''
            )}
          </>
        }
        actions={
          <Button
            disabled={!props.credasLicensed || props.anonymous}
            onClick={props.gotoCredasPage}
          >
            {credasConnected ? 'Edit account' : 'Connect account'}
          </Button>
        }
      />
    </Container>
  );
};

export default FormBuilderIntegrationsView;
